import { Injectable } from '@angular/core';
import { Lock } from './../model/Lock';

@Injectable({
  providedIn: 'root'
})
export class LockService {

  private _locks: Lock[] = [
    new Lock(1, 3, 10, 10000, "DE JUGUETE", "Es tan tierno..."),
    new Lock(1, 3, 7, 10000, "BÁSICO", "Casi como no tener nada puesto"),
    new Lock(1, 3, 5, 10000, "FÁCIL", "Peor es nada.. no?"),
    new Lock(1, 4, 7, 10000, "REFORZADO", "5 dígitos son mejores que 4. Sin duda."),
    new Lock(1, 4, 5, 10000, "REFORZADO x 2", "5 dígitos son mejores que 4. Y con menos intentos!"),
    new Lock(1, 5, 10, 10000, "MADNESS", "6 dígitos de pura maldad"),
    new Lock(1, 5, 8, 10000, "IMPOSIBLE", "Mejor que ni lo intenten")
  ]
  constructor() { }

  public getAll() {
    return Promise.resolve(this._locks);
  }

  public getRandom() {
    return this._locks[Math.round(Math.random() * (this._locks.length - 1))];
  }

  public getImages(): string[] {
    return this._locks.map(l => l.image);

  }
}
